import { getTheme } from "../../../configs/themes";
import React, { useRef, useState } from "react";

import Cards from "./partials/Cards";
import { DataProvider } from "./hooks/DataContext";
import EmailVerification from "../../EmailVerification/EmailVerification";
import Filter from "./partials/Filter/Filter";
import GardenProductionComponent from "./components";
import ButtonComponent from "../../../components/atoms/ButtonComponent";
import { TbFilter } from "react-icons/tb";
import { ConfigProvider, Modal } from "antd";
import ModalFilter from "./partials/ModalFilter";

export const pagePath = "produksi_kebun";

const GardenProduction = () => {
  const componentRef = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  return (
    <DataProvider>
      <div
        ref={componentRef}
        className="relative grid max-h-screen w-full gap-13 bg-gray-30 pb-16 pt-42 md:grid-rows-[minmax(0px,50px)_minmax(0px,50px)_minmax(0px,0.5fr)_minmax(0px,0.5fr)] md:py-16 md:pb-0"
      >
        <ConfigProvider
          theme={{
            token: { colorPrimary: getTheme().primary },
          }}
        >
          <Modal
            title="Filter"
            zIndex={10}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={showModal}
            wrapClassName="backdrop-blur-sm"
            footer={
              <div className="flex flex-row items-center justify-end space-x-16 pt-16">
                <ButtonComponent
                  value="Tutup"
                  type="submit"
                  size="none"
                  className="button-transition px-16 py-8 text-16"
                  onClick={handleOk}
                />
              </div>
            }
          >
            <ModalFilter />
          </Modal>
        </ConfigProvider>
        {/*<EmailVerification />*/}
        <GardenProductionComponent.Heading />
        <Filter ref={componentRef} />
        <Cards />
        <div className="h-full w-full px-16 md:px-[2%]">
          <GardenProductionComponent.ComparisonChart title="Produksi Kebun vs Penerimaan PKS" />
        </div>
        <ButtonComponent
          tooltipPlacement="bottom"
          tooltipTitle="Filter"
          value="Filter"
          size="none"
          type="button"
          className="bordered-button-transition fixed bottom-16 right-16 z-20 -ml-8 w-fit rounded-16 bg-red-mobile p-10 text-16 text-white md:hidden"
          onClick={showModal}
          icon={<TbFilter className="text-18 text-white" />}
        />
      </div>
    </DataProvider>
  );
};

export default GardenProduction;
